<template>
    <div v-loading="pageLoading">
        <xi-top></xi-top>
        <div class="center-container">
            <div class="top-out-wrapper">
                <div class="top-bg-wrapper">
                    <div class="top-inner-wrapper">
                        <img :src="userObj.userPortrait100">
                        <div class="top-center-wrapper">
                            <span>{{userObj.nickname}}</span>
                            <div class="authorization"><span>{{ getLabel}}</span></div>
                            <div class="datas">
                                <router-link v-if="userObj.userStatus > 0" @click.native="readAllMessage();getNewStatus();"
                                             :to="{name:'copyrighterMessage'}" class="item">
                                    <span class="data">{{ unReadMessageCount }}</span>
                                    <span class="title">{{ $t('word.message') }}</span>
                                </router-link>
                                <div class="item" v-else>
                                    <span class="data">0</span>
                                    <span class="title">{{ $t('word.message') }}</span>
                                </div>
                                <router-link  @click.native="getNewStatus();"
                                             :to="{name:'WriterCenterEvents'}" class="item">
                                    <span class="data">{{ unReadEvent }}</span>
                                    <span class="title">{{ $t('word.vacate') }}</span>
                                </router-link>
                                <router-link  @click.native="getNewStatus();"
                                             :to="{name:'copyrighterAnnouncement'}" class="item">
                                    <span class="data">{{ unReadAnnouncement }}</span>
                                    <span class="title">{{ $t('word.announcement') }}</span>
                                </router-link>
                            </div>
                        </div>
                        <div class="top-tail-wrapper">
                            <button @click="dialogVisible=true" :disabled="userObj.userStatus!==9">{{ $t('comb.uploadWork') }}</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="content-out-wrapper">
                <div class="content-inner-wrapper">
                    <div class="content-left">
                        <div class="center-works-category">
                            <router-link  @click.native="getNewStatus" active-class="active" :to="{name: 'worksManagement'}">
                                <div class="sticker"></div><i class="icon icon-20 icon-copyright-management va-mid mr10"></i><span>{{ $t('comb.copyrightWorkManagement') }}</span>
                            </router-link>
                            <router-link  @click.native="getNewStatus" active-class="active" :to="{name: 'taskManagementList'}">
                                <div class="sticker"></div><i class="icon icon-20 icon-task-management va-mid mr10"></i><span>{{ $t('comb.releasedTask') }}</span>
                            </router-link>
                            <a href="http://www.ximalaya.com/center/tradeRecord" target="_blank"><div class="sticker"></div><i class="icon icon-20 icon-earning-detail va-mid mr10"></i><span>{{ $t('comb.earningDetail') }}</span></a>
                            <router-link  @click.native="getNewStatus" active-class="active" :to="{name: 'dataAnalysis'}">
                                <div class="sticker"></div><i class="icon icon-20 icon-data-analysis va-mid mr10"></i><span>{{ $t('comb.dataAnalysis') }}</span>
                            </router-link>
                        </div>
                    </div>
                    <div class="content-right">
                        <router-view></router-view>
                    </div>
                </div>
            </div>
        </div>
        <xi-foot></xi-foot>
        <el-dialog v-model="showLastAnnouncement" :close-on-click-modal="false" custom-class="announcement-pop" :show-close="false" top="30%">
            <div slot="title" style="text-align: center;">{{ $t('word.announcement') }}</div>
            <div slot="" class="announcement">
                <div class="title"><span v-if="lastAnnouncement">{{ lastAnnouncement.title }}</span></div>
                <p v-if="lastAnnouncement">{{ lastAnnouncement.content }}</p>
            </div>
            <div slot="footer" style="text-align: center;">
                <button class="pop-button" @click="closeAnnouncementPop">{{ $t('word.close') }}</button>
            </div>
        </el-dialog>
        <el-dialog title="页面跳转" custom-class="detailDialog" v-model="dialogVisible" size="mini">
            <span>为了更好地为您服务，将前往喜配音平台进行后续操作！</span>
            <div class="buttons">
              <el-button type="primary" plain @click="dialogVisible=false">{{ $t('word.cancel') }}</el-button>
              <a type="button" class="agree-btn" @click="dialogVisible=false" target="_blank" :href="$store.state.DUB_HOST">跳转至喜配音</a>
            </div>
        </el-dialog>
    </div>
</template>
<style lang="sass" scope>
    @import "../../../sass/copyright/center/center.scss";
    @import "../../../sass/icons.scss";
</style>
<script>
    import XiFoot from '../../components/Footer.vue';
    import XiTop from '../../components/Top.vue';
    import axios from 'axios';
    export default {
        data () {
            return {
              dialogVisible: false,
              showLastAnnouncement: false,
              lastAnnouncement: {},
              unReadMessageCount: 0,
              unReadAnnouncement: 0,
              pageLoading: true
            }
        },
        beforeMount() {
            this.getInit();
            this.setXMLog();
        },
        mounted() {
            this.$store.dispatch('getUser');
        },
        methods: {
            getInit () {
                this.getUnreadMessage();
                this.getUnHandlerEventCount();
                this.getUnreadAnnounceMent();
            },
            addWorks() {
                this.$router.push({name: 'uploadCopyright'});
            },
            getUser(user) {
                user.nickname = this.$store.state.user.name;
                user.userStatus = this.$store.state.user.author.authorProgressStatus;
                user.userStatusLabel = this.$store.state.user.author.authorProgressLabel;
                user.userType = this.$store.state.user.author.type;
                user.userTypeLabel = this.$store.state.user.author.typeLabel;
                user.rejectedReason = this.$store.state.user.author.rejectionReason;
                let logoPic = this.$store.state.user.logoPic;
                const UPLOAD_IMG_HOST = this.$store.state.UPLOAD_IMG_HOST;
                const DEFAULT_PORTRAIT_100 = this.$store.state.DEFAULT_PORTRAIT_100;
                const DEFAULT_PORTRAIT_200 = this.$store.state.DEFAULT_PORTRAIT_200;
                const WEB_LARGE = '_web_large.';
                user.userPortrait200 = logoPic ? (/^([hH][tT]{2}[pP])/.test(logoPic) ? logoPic : `${UPLOAD_IMG_HOST}${logoPic.split('.')[0]}${WEB_LARGE}${logoPic.split('.')[1]}`) : `${DEFAULT_PORTRAIT_200}`;
                user.userPortrait100 = logoPic ? (/^([hH][tT]{2}[pP])/.test(logoPic) ? logoPic : `${UPLOAD_IMG_HOST}${logoPic.split('.')[0]}${WEB_LARGE}${logoPic.split('.')[1]}`) : `${DEFAULT_PORTRAIT_100}`;
            },
            getNewStatus() {
                this.getUnreadMessage();
                this.getUnHandlerEventCount();
                this.getUnreadAnnounceMent();
            },
            getUnreadMessage () {
                axios.get('/api/message/unread/count').then(res => {
                    this.unReadMessageCount = res.data.data;
                });
            },
            getUnHandlerEventCount () {
                const that = this;
                axios.get(`/api/event/vacation/count`).then(res => {
                    if (res.data.code === 200) {
                        that.unread = res.data.data.unaudited;
                        this.$store.commit('UPDATE_UNHANDLE_EVENT', that.unread);
                    }
                });
            },
            getUnreadAnnounceMent () {
                axios.get('/api/notice/new?type=author').then(res => {
                    this.unReadAnnouncement = res.data.data.unreadCount;
                    this.pageLoading = false;
                    this.lastAnnouncement = res.data.data.lastNotice;
                    if (this.lastAnnouncement) {
                        this.showLastAnnouncement = true;
                    }
                });
            },
            readAllMessage () {
                this.unReadMessageCount = 0;
            },
            applay () {
              this.$router.push({ name: 'copyrighterApply'});
            },
            editApply () {
                this.$router.push({ name: 'copyrighterApply'});
            },
            deleteApply () {
                const that = this;
                axios.post('/api/author/apply/cancel').then(res => {
                    if (res.data.code === 200) {
                        window.location.reload();
                    } else {
                        that.$message({
                            type: 'warning',
                            message: res.data.message
                        })
                    }
                });

            },
            closeAnnouncementPop () {
              this.showLastAnnouncement = false;
              axios.get(`/api/notice/detail/${this.lastAnnouncement.id}`).then(res => {

              });
            },
            setXMLog () {
                xmLog('pv.create', {
                  item: "版权方工作台"
                })
                xmLog("pv.send", "event", {
                  serviceId: "aBookView",
                  item: "版权方工作台"
                })
            }
        },
        components: {
            XiTop,
            XiFoot
        },
        computed: {
            userObj() {
                let userObj = {
                    userPortrait200: '',
                    userPortrait100: '',
                    nickname: '',
                    userStatus: '',
                    userStatusLabel: '',
                    userType: '',
                    userTypeLabel: '',
                    rejectedReason:''
                };
                this.getUser(userObj);
                return userObj;
            },
            IMG_HOST() {
                return this.$store.state.IMG_HOST;
            },
            unReadEvent () {
                return this.$store.state.UNHANDLE_EVENT;
            },
            getLabel() {
                const user = this.$store.state.user;
                if (user.author.authorProgressStatus === 1 || user.author.authorProgressStatus === 5) {
                    return user.author.typeLabel + user.author.authorProgressLabel;
                } else if(user.author.authorProgressStatus === 9) {
                    return user.author.authorProgressLabel + user.author.typeLabel;
                } else {
                    // 未登录，未入驻
                    return user.author.authorProgressLabel + user.author.typeLabel;
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// Center.vue?25f18856